import { useState } from "react";
import type { AxiosError } from "axios";
import { api } from "../../../utils/api";
import type { ExtensionFormRequest } from "../../../models/interface/app-download.interface";

type UseExtensionFormReturn = {
  submitting: boolean;
  error: string | null;
  submitExtensionForm: (payload: ExtensionFormRequest) => Promise<void>;
};

export const useExtensionForm = (): UseExtensionFormReturn => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitExtensionForm = async (
    payload: ExtensionFormRequest,
  ): Promise<void> => {
    setSubmitting(true);
    setError(null);
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const finalPayload = {
      ...payload,
      timezone: clientTimezone,
    };
    try {
      await api.post("/api/licenses/register", finalPayload);
    } catch (err) {
      const axiosError = err as AxiosError<{ message?: string }>;
      const message =
        (axiosError.response?.data?.message as string | undefined) ??
        axiosError.message ??
        "Failed to register license";

      setError(message);
      throw err;
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, error, submitExtensionForm };
};
